export default {
  methods: {
    formattedFilter(list, value) {
      let filter = this.selectedFiltersTitles(list, value)

      if (filter.length > 2) {
        return filter.slice(0, 2).join(', ') + '...'
      } else {
        return filter.join(', ')
      }
    },

    selectedFiltersTitles(list, value) {
      let filters = list.filter(el => {
        return value.includes(el.item_value)
      })
      return filters.map(({ title }) => title)
    }
  }
}
